import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-servicios',
  templateUrl: './create-servicios.component.html',
  styleUrls: ['./create-servicios.component.scss']
})
export class CreateServiciosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
